import { Form } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";

interface FilterSectionProps {
  selectedSituation?: string[];
  handleSituationFilter: (value: string | string[]) => void;
  allSituations?: string[];
}

const FilterSection = ({
  selectedSituation = [],
  handleSituationFilter,
  allSituations = [],
}: FilterSectionProps) => {
  const handleCheckboxChange = (label: string) => {
    handleSituationFilter(label);
  };

  const isAllSelected =
    allSituations.length > 0 &&
    allSituations.every((s) => selectedSituation.includes(s));

  const handleToggleAll = () => {
    if (isAllSelected) {
      handleSituationFilter([]);
      return;
    }
    handleSituationFilter([...allSituations]);
  };

  return (
    <div className="filters-section">
      <div className="filter-label">
        <FaFilter style={{ marginRight: "5px" }} /> Situação:
      </div>

      <div className="checkbox-grid">
        <div className="checkbox-line">
          <Form.Check
            id="analysis-filter-all"
            inline
            label="Todos"
            type="checkbox"
            checked={isAllSelected}
            onChange={handleToggleAll}
          />
        </div>

        <div className="checkbox-line">
          <Form.Check
            id="analysis-filter-documentacao-pendente"
            inline
            label="Doc. Pendente"
            type="checkbox"
            checked={selectedSituation.includes("Documentação Pendente")}
            onChange={() => handleCheckboxChange("Documentação Pendente")}
          />
          <Form.Check
            id="analysis-filter-documentacao-enviada"
            inline
            label="Doc. Enviada"
            type="checkbox"
            checked={selectedSituation.includes("Documentação Enviada")}
            onChange={() => handleCheckboxChange("Documentação Enviada")}
          />
          <Form.Check
            id="analysis-filter-analise-pendente"
            inline
            label="Análise Pendente"
            type="checkbox"
            checked={selectedSituation.includes("Análise Pendente")}
            onChange={() => handleCheckboxChange("Análise Pendente")}
          />
          <Form.Check
            id="analysis-filter-analise-andamento"
            inline
            label="Análise em Andamento"
            type="checkbox"
            checked={selectedSituation.includes("Análise em Andamento")}
            onChange={() => handleCheckboxChange("Análise em Andamento")}
          />
        </div>

        <div className="checkbox-line">
          <Form.Check
            id="analysis-filter-adequacao-pendente"
            inline
            label="Adeq. Pendente"
            type="checkbox"
            checked={selectedSituation.includes("Adequação Pendente")}
            onChange={() => handleCheckboxChange("Adequação Pendente")}
          />
          <Form.Check
            id="analysis-filter-analise-concluida"
            inline
            label="Análise Concluída"
            type="checkbox"
            checked={selectedSituation.includes("Análise Concluída")}
            onChange={() => handleCheckboxChange("Análise Concluída")}
          />
          <Form.Check
            id="analysis-filter-inapto"
            inline
            label="Inapto"
            type="checkbox"
            checked={selectedSituation.includes("Inapto")}
            onChange={() => handleCheckboxChange("Inapto")}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterSection;
